.envoltorio {
  display: inline-flex;
  align-items: flex-start;
  gap: var(--s-5);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.envoltorio[data-disabled] {
  cursor: not-allowed;
}

/* Oculto pero enfocable: nada de `display: none`, que lo saca del teclado. */
.oculto {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  outline: none;
  box-shadow: none;
}

/* 18px, radio 4, borde 1.5 gray-400. Marcada: accent lleno con la tilde blanca. */
.caja {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  /* Centrado con la primera línea del texto (fs-xs × lh-relaxed ≈ 21px). */
  margin-top: 2px;
  border-radius: var(--r-xs);
  background: var(--surface-card);
  border: var(--bw-control) solid var(--border-hover);
  color: var(--action-primary-text);
  transition:
    background var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}
.tilde,
.raya {
  display: inline-flex;
  opacity: 0;
  transform: scale(0.6);
  transition:
    opacity var(--dur-fast) var(--ease-standard),
    transform var(--dur-fast) var(--ease-standard);
}
.raya {
  width: 10px;
  height: var(--bw-control);
  border-radius: var(--r-full);
  background: currentColor;
}

.oculto:checked + .caja,
.oculto:indeterminate + .caja {
  background: var(--action-primary);
  border-color: var(--action-primary);
}
.oculto:checked + .caja .tilde,
.oculto:indeterminate + .caja .raya {
  opacity: 1;
  transform: none;
}
.oculto:indeterminate + .caja .tilde {
  display: none;
}
.oculto:focus-visible + .caja {
  box-shadow: var(--ring-focus);
  border-color: var(--border-brand);
}
.oculto:disabled + .caja {
  background: var(--control-disabled-bg);
  border-color: var(--control-disabled-border);
  color: var(--control-disabled-text);
}
.oculto:disabled:checked + .caja,
.oculto:disabled:indeterminate + .caja {
  background: var(--control-disabled-border);
  border-color: var(--control-disabled-border);
  color: var(--brand-white);
}
@media (hover: hover) {
  .envoltorio:not([data-disabled]):hover .oculto:not(:checked) + .caja {
    border-color: var(--border-brand);
  }
}

.texto {
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  min-width: 0;
}
.etiqueta {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  color: var(--text-strong);
}
.descripcion {
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  line-height: var(--lh-normal);
  color: var(--text-muted);
}
.envoltorio[data-disabled] .etiqueta {
  color: var(--control-disabled-text);
}

@media (prefers-reduced-motion: reduce) {
  .caja,
  .tilde,
  .raya {
    transition: none;
  }
}
